/*jshint ignore:start*/

(function()
{
	function Challenge(opts)
	{
		this.View_constructor();

		// Keeps track of garment parts. When middle/torso is filled, it fades out other
		// middle/torso pieces, etc.
		this.garments = {
			top: [],
			middle: [],
			bottom: []
		};

		this._t = 0;

		// Track if the costume is finished.
		this.costumePartCount = 0;

		this.wrongAnswerCounter = 0;
		this.wrongAnswerTotal = 0;
		this.hintTotal = 0;

		this.defaultCharacterLimbs = {};

		this.activeGarmentButtons = [];

		this.interactionTarget = null;
		this.interactionLocation = null;


		this.challengeSetType = opts.challengeSetType;
		this.challengeSetConfig = opts.challengeSetConfig || {}; 
		this.snapshotModeOnly = !!opts.snapshotModeOnly;

		this.isInSnapshotMode = false;
		this.idleType = 1;

		// reusable rectangle instance for the hitboxes of the items.
		this.interactingItemBounds = new cjs.Rectangle();


		var bg = new cjs.Bitmap(cm.Assets.lib.ChallengeBG);
		this.bg = bg;
		bg.center();
		this.addChild(bg);



		if (!this.snapshotModeOnly) 
		{

			// Set up the character movieclip.
			var charname = cm.app.game.currentCharacterName;
			this.characterMovieClip = new cm.Assets.lib.MainAnimsLib["mc_paperdoll_" + charname + "_sorting_idle"]();
			this.characterMovieClip.changeSnapToPixel(false);

			if (charname === 'elmo') {
				this.characterMovieClip.setScale(0.89).set({x: -142, y: -98});
			} else if (charname === 'abby') {
				this.characterMovieClip.setScale(0.79).set({x: -127, y: -58});
			}

			this.characterMovieClip.set({framerate: 30});

			var head = this.characterMovieClip.getBodypartInstances('mc_'+ cm.app.game.currentCharacterName + '_container_head')[0];
			console.log(head);
			this.characterLipsyncContainer = head.lipsyncMouthContainer;
			
			// this.characterLipsyncContainer.default_mouth.framerate = 30;
			

			// Find draggable button classes, label them for later.
			cm.app.game.setMovieClipClassNames(cm.Assets.lib.ChallengeSetAnimsLib);

			
			this.challengeSetItemButtons = new cm.Assets.lib.ChallengeSetAnimsLib[this.challengeSetConfig.mc_name]();
			this.challengeSetItemButtons.set({name: 'challenge_set_buttons', regX: 512, regY: 330, scaleX: 1.05, scaleY: 1.05});

			this.dragContainer = new cjs.Container().setScale(1.05);

			this.addChild(
				this.characterMovieClip,
				this.challengeSetItemButtons,
				this.dragContainer
			);

			this.challengeSetItemButtons.gotoAndStop(0);
			this.challengeSetItemButtons.changeSnapToPixel(false);

			// Loop the instances and list them into garment categories, so that when one garment is chosen,
			// the others of that category can be disabled. (can't have multiple pairs of shoes being used for instance)
			var i = 1;
			var instance = this.challengeSetItemButtons.instance;
			var name;

			var floatPhaseOffset = 0;

			while (instance)
			{
				// name format is 'btn_{costumeName}_{top|middle|bottom}', ex: btn_bearPattern_top
				name = instance.className.split('_');
				instance.gotoAndStop('up');
				instance.set({mouseChildren: false});
				instance.defaultPosition = {x: instance.x, y: instance.y};

				cm.app.game.iterateMCInstances(instance, function(oI) {
					// Set hitboxes on the texture symbols, as using a hitbox directly on 
					// the parent movieclip is frequently too large or positioned slightly wrong.
					if (oI.className.indexOf('texture_btn') === 0)
					{	
						oI.hitbox(0, oI.nominalBounds);
					}
				});

				this.garments[name[2]].push(instance);
				this.activeGarmentButtons.push(instance);

				instance._defaultRegY = instance.regY;
				instance._defaultRegX = instance.regX;
				instance.floatPhaseOffset = floatPhaseOffset;
				instance._floatingTime = 0;
				floatPhaseOffset += Math.PI/8;


				instance = this.challengeSetItemButtons['instance_'+i];
				i++;
			}
		}

		this.snapshotModeMovieClip = new cm.Assets.lib.MainAnimsLib.mc_snapshotMode_container();
		this.snapshotModeMovieClip.set({x: -512, y: -330, framerate: 30});


		this.menuBtn = new cm.Assets.lib.MainAnimsLib.btn_menu();
		this.menuBtn.set({x: -cm.app.display.width/2, y: -cm.app.display.height/2, mouseChildren: false});
		this.menuBtn.stop();

		this.addChild(this.menuBtn);
		
	}

	var p = createjs.extend(Challenge, cm.View);


	p.start = function() 
	{


		if (this.snapshotModeOnly)
		{
			cm.analytics.startRound('Snapshot Round 3');
			this.startInSnapshotMode();
		}
		else 
		{	
			var charName = cm.app.game.currentCharacterName;
			if (this.challengeSetType === 'free')
			{
				this.characterLipsyncContainer.playLipsync(charName + '_free_request', this.allowIdle.bind(this));
			} 
			else 
			{
				var vo = [
					// eg: abby_like_request
					charName + '_' + this.challengeSetType + '_request',
					// eg: abby_like-bear_roundIntro
					charName + '_' + this.challengeSetType + '-' + this.challengeSetConfig.solution_name + '_roundIntro'
				];

				// Play extra line of vo if we're in some special season.
				if (cm.app.game.season !== 'default' && !cm.app.game.hasPlayedSeasonalShowcase)
				{
					cm.app.game.hasPlayedSeasonalShowcase = true;
					vo.unshift(charName + '_' + cm.app.game.season + '_challengePackIntro');
				}

				cm.app.voPlayer.play(cm.soundDictionary.getSoundID(vo), this.allowIdle.bind(this));
			}

			var location ='Dressup Round ' + cm.app.game.currentGamePhase;
			var challenge = this.challengeSetConfig.analytics_name;
			cm.analytics.event('QuestionAsked', location + '_' + challenge, null);
			cm.analytics.startRound(location, challenge);

			this.hintTimestamp = Date.now();

			this.setActive(true);
		}

		this.musicLoop = cm.app.sound.play('DressUpMusic_02', {volume: 0, loop: true});
		cm.app.sound.fadeIn(this.musicLoop, 300, 0.3, 0);
	};


	p.allowIdle = function() 
	{	
		this.idleAllowed = true;
		this.idleTimer = 0;
	};

	p.destroy = function() 
	{
		this.View_destroy();
		cm.app.sound.fadeOut(this.musicLoop);
	};


	p.onQuitGame = function() 
	{
		if (this.isInSnapshotMode)
		{
			cm.analytics.quitGame(
				'Snapshot Round ' + cm.app.game.currentGamePhase
			);
		}
		else 
		{
			cm.analytics.quitGame(
				'Dressup Round ' + cm.app.game.currentGamePhase, 
				this.challengeSetConfig.analytics_name
			);
		}
	};


	p.setActive = function(active) 
	{	

		if (active === true) 
		{	
			if (this.challengeSetItemButtons) 
			{
				this.challengeSetItemButtons.on('mousedown', this.handleCostumeButtonsInteraction, this);
				this.menuBtn.on('click', this.handleMenuBtnInteraction, this);

				if (!cm.Device.mobile) 
				{
					this.challengeSetItemButtons.on('mouseover', this.handleCostumeButtonsInteraction, this);
					this.challengeSetItemButtons.on('mouseout', this.handleCostumeButtonsInteraction, this);
					this.menuBtn.on('mouseover', this.handleMenuBtnInteraction, this);
					this.menuBtn.on('mouseout', this.handleMenuBtnInteraction, this);
				}

			}
		} 
		else 
		{
			if (this.challengeSetItemButtons) 
			{
				this.challengeSetItemButtons.removeAllEventListeners();
			}
			this.menuBtn.removeAllEventListeners();
			this.snapshotModeMovieClip.removeAllEventListeners();
		}
	};


	p.handleMenuBtnInteraction = function(e)
	{
		var target = e.target;

		switch (e.type) 
		{
			case 'click':

				if (this.isInSnapshotMode)
				{
					cm.analytics.menuButtonPressed('Snapshot Round ' + cm.app.game.currentGamePhase)
				} 
				else
				{
					cm.analytics.menuButtonPressed('Dressup Round ' + cm.app.game.currentGamePhase, this.challengeSetConfig.analytics_name)
				}

				e.target.mouseEnabled = false;

				cm.app.voPlayer.stop();
				cm.app.game.gotoCharacterSelect();
				break;

			case 'mouseover':

				cm.app.game.hoverCursor();
				e.target.gotoAndStop('over');
				cm.app.sound.play('charsel_btn_rollover', {volume: 0.6});
				break;

			case 'mouseout':

				cm.app.game.unhoverCursor();
				e.target.gotoAndStop('up');
				break;

			default:
				break;
		}

	};



	p.handleCostumeButtonsInteraction = function(e)
	{
		var target = e.target;

		switch (e.type) 
		{
			case 'mousedown':

				if (this.isInteracting === true && target !== this.interactionTarget)
				{
					// prevent double-selection on desktop when using click-and-pick instead of drag.
					return;
				}

				// get rid of hint highlights..
				for (var i = 0, l = this.activeGarmentButtons.length; i < l; i++)
				{
					this.activeGarmentButtons[i].gotoAndStop('up');
				}

				cm.app.sound.play('click1', {volume: 0.6});
				target.gotoAndStop('up');
				this.allowIdle();

				this.interactionTarget = target;
				this.isInteracting = true;

				target.parent.localToLocal(target.x, target.y, this.dragContainer, target);
				this.dragContainer.addChild(target);


				if (!cm.Device.mobile)
				{
					this.itemFollowingCursor = true;
					this.interactionStartTime = Date.now();
				}

				target.on("pressmove", this.itemDrag, this);
				target.on("pressup", this.itemDrag, this);
				break;
			case 'mouseover':
				if (this.isInteracting) {
					break;
				}
				target._isInteracting = true;
				cm.app.game.hoverCursor();
				cm.app.sound.play('ro1', {volume: 0.5});
				target.gotoAndStop('over');
				break;
			case 'mouseout':
				if (this.isInteracting) {
					break;
				}
				target._isInteracting = false;
				cm.app.game.unhoverCursor();
				target.gotoAndStop('up');
				break;
			default:
				break;
		}

	};

	p.itemDrag = function(e)
	{
		var target = e.target;

		if(e.type === "pressup")
		{	
			if (cm.Device.mobile || this.isDraggingItem)
			{
				target.removeAllEventListeners();
				this.checkDrop(target);
				this.interactionTarget = null;
				this.interactionLocation = null;
				this.isInteracting = false;
				this.isDraggingItem = false;
				this.itemFollowingCursor = false;
			}
			else if (this.itemFollowingCursor)
			{
				if (!this.cursorFollowToggled)
				{
					this.cursorFollowToggled = true;
				}
				else if (this.cursorFollowToggled)
				{
					target.removeAllEventListeners();
					this.checkDrop(this.interactionTarget);
					this.interactionTarget = null;
					this.interactionLocation = null;
					this.isInteracting = false;
					this.isDraggingItem = false;
					this.cursorFollowToggled = false;
					this.itemFollowingCursor = false;
				}
			}
			
		} 
		else if (e.type === "pressmove")
		{
			if (!cm.Device.mobile)
			{
				if (Date.now() - this.interactionStartTime < 100)
				{
					return;
				}
				if (this.itemFollowingCursor)
				{
					this.cursorFollowToggled = false;
					this.itemFollowingCursor = false;
					this.isDraggingItem = true;
				} 

				if (this.isDraggingItem) 
				{
					target.parent.globalToLocal(e.stageX,e.stageY, target);
				}
			}
			else 
			{
				target.parent.globalToLocal(e.stageX,e.stageY, target);
			}
			
		}
	};

	p.checkDrop = function(costumePart) {

		var charMCBounds = this.characterMovieClip.getTransformedBounds();
		var itemBounds = costumePart.getTransformedBounds().clone();

		var p = costumePart.parent.localToLocal(itemBounds.x, itemBounds.y, this);

		itemBounds.x = p.x;
		itemBounds.y = p.y;

		if (charMCBounds.intersects(itemBounds) && this.isCostumePartInSolutionSet(costumePart)) 
		{

			// Correct costume 
			var gar = this.garments[costumePart.className.split('_')[2]];
			for (var i = 0, l = gar.length; i < l; i++) 
			{
				// fade out all costume parts of this type.
				// if they choose shoes, fade out all the un-used shoes.
				gar[i].mouseEnabled = false;
				this.activeGarmentButtons.erase(gar[i]);
				gar[i].gotoAndStop('up');
				cjs.Tween.get(gar[i])
					.to({alpha: 0.4}, 200, cjs.Ease.quadInOut);
			}

			this.cancelWrongAnswerHint();

			this.activeGarmentButtons.erase(costumePart);

			this.characterLipsyncContainer.default_mouth.gotoAndPlay('happy');

			cm.app.sound.play('CA1');

			this.addCostumePartToCharacter(costumePart);
			cjs.Tween.get(costumePart, {override: true})
				.to({alpha: 0}, 300, cjs.Ease.quadInOut)
				.set({visible: false});


			var location ='Dressup Round ' + cm.app.game.currentGamePhase;
			var challenge = this.challengeSetConfig.analytics_name;

			cm.analytics.challengeRightAnswer(
				location,
				challenge,
				this.costumePartCount,
				this.hintTotal,
				Date.now() - this.hintTimestamp
			)

			this.wrongAnswerCounter = 0;


		} 
		else if (charMCBounds.intersects(itemBounds))
		{
			// WRONG costume
			this.wrongAnswerCounter++;
			this.wrongAnswerTotal++;

			var location ='Dressup Round ' + cm.app.game.currentGamePhase;
			var challenge = this.challengeSetConfig.analytics_name;
			cm.analytics.challengeWrongAnswer(
				location,
				challenge,
				this.hintTotal,
				Date.now() - this.hintTimestamp
			);


			this.hintTimestamp = Date.now();
			costumePart.set(costumePart.defaultPosition);
			this.challengeSetItemButtons.addChild(costumePart);
			cm.app.sound.play('WA2');
			this.playWrongAnswerHint();

		} 
		else 
		{
			costumePart.set(costumePart.defaultPosition);
			this.challengeSetItemButtons.addChild(costumePart);
		}

	};

	p.playWrongAnswerHint = function() 
	{
		var charName = cm.app.game.currentCharacterName;

		this.hintTotal++;

		if (this.wrongAnswerCounter === 1)
		{
			cm.app.voPlayer.play(cm.soundDictionary.getSoundID(charName + '_wrong1'));
		}
		else if (this.wrongAnswerCounter === 2)
		{
			var vo = [
				charName + '_wrong2_' + this.challengeSetType,
				// eg: abby_like-bear_roundIntro
				charName + '_' + this.challengeSetType + '-' + this.challengeSetConfig.solution_name + '_roundIntro'
			];

			if (this.challengeSetType === 'pattern')
			{
				vo.push(charName + '_specialhelp_' + this.challengeSetConfig.solution_name);
			}
			cm.app.voPlayer.play(cm.soundDictionary.getSoundID(vo));
		}
		else if (this.wrongAnswerCounter >= 3)
		{
			cm.app.voPlayer.play(cm.soundDictionary.getSoundID(charName + '_wrong3'));

			for (var i = 0, l = this.activeGarmentButtons.length; i < l; i++)
			{
				this.activeGarmentButtons[i].gotoAndStop('up');
			}

			var ag;
			if (this.challengeSetType === 'like')
			{
				for (var i = 0, l = this.activeGarmentButtons.length; i < l; i++)
				{
					if (this.activeGarmentButtons[i].className.split('_')[1] === this.challengeSetConfig.solution_name)
					{
						ag = this.activeGarmentButtons[i];
						break;
					}
				}
			}
			else 
			{
				for (var i = 0, l = this.activeGarmentButtons.length; i < l; i++)
				{
					if (this.isCostumePartInSolutionSet(this.activeGarmentButtons[i]))
					{
						ag = this.activeGarmentButtons[i];
						break;
					}
				}
			}


			if (ag)
			{
				this.garmentHintTween = cjs.Tween.get(ag, {override: true})
					.wait(1500)
					.call(ag.gotoAndStop, ['over'])
					.to({scaleX: 1.1, scaleY: 1.1, rotation: 10}, 150, cjs.Ease.quadInOut)
					.to({scaleX: 1, scaleY: 1, rotation: 0}, 150, cjs.Ease.quadInOut);
			}

		}
	};

	p.cancelWrongAnswerHint = function() 
	{
		if (this.garmentHintTween)
		{
			cm.app.voPlayer.stop();
			this.garmentHintTween.setPaused(true);
			this.garmentHintTween = null;
		}
	};

	p.isCostumePartInSolutionSet = function(costumePart) 
	{
		var sol = this.challengeSetConfig.solutions;
		var name;
		var isInSet = false;

		if (sol === 'setname') 
		{
			name = costumePart.className.split('_')[1];
			isInSet = name === this.challengeSetConfig.id;
		}
		else if (sol === 'all') 
		{
			isInSet = true;
		} 
		else 
		{
			name = costumePart.className.replace('btn_', '');
			isInSet = sol.indexOf(name) !== -1;
		}

		return isInSet;
	};

	p.addCostumePartToCharacter = function(item) 
	{
		// format is 'btn_{costumeName}_{top|middle|bottom}', ex: btn_bearPattern_top
		var name = item.className.split('_');
		// Remove pattern or color from the name, so we can figure out what costume lib to use.
		var costumeLibName = name[1].replace(/Color|Pattern/g, '') + cm.app.game.costumePartsLibIDSlug;

		var costumeName = name[1]; // eg "bearPattern"
		var costumePart = name[2]; // eg "top"

		this.costumePartCount++;

		cm.app.game.selectedCostumes[cm.app.game.currentGamePhase][costumePart] = costumeName;
	
		switch (costumePart) 
		{
			case 'top': 
				this.changeCostumeTop(costumeLibName, costumeName, this.characterMovieClip);
				break;
			case 'middle':
				this.changeCostumeMiddle(costumeLibName, costumeName, this.characterMovieClip);
				break;
			case 'bottom':
				this.changeCostumeBottom(costumeLibName, costumeName, this.characterMovieClip);

				break;
			default: 
				break;
		}

		if (this.costumePartCount === 3) 
		{
			// WE DONE
			
			// analytics..
			var costume = cm.app.game.howManySameOutfitParts(cm.app.game.currentGamePhase) === 3 ? 'Full Costume' : 'Mixed Costume';

			cm.analytics.endChallengeRound(
				'Dressup Round ' + cm.app.game.currentGamePhase, 
				this.challengeSetConfig.analytics_name,
				costume,
				this.hintTotal,
				this.wrongAnswerTotal
			);
			
			// Go to snap picture mode or whatever.
			this.costumeComplete();
		
		}
	};



	p.costumeComplete = function() {
		var costumeName;
		var costumePart;
		var name;
		var costumeLibName;
		var snapshotContainer;
		var label;
		var bgBitmap;


		switch (cm.app.game.currentGamePhase) 
		{
			case cm.GamePhases.CHALLENGE_SPECIFIC_COSTUME:

				console.log(this._getSnapshotBGImg(cm.GamePhases.CHALLENGE_SPECIFIC_COSTUME));
				bgBitmap = new cjs.Bitmap(this._getSnapshotBGImg(cm.GamePhases.CHALLENGE_SPECIFIC_COSTUME));
				this.snapshotModeMovieClip.snapshotContainer1_1.snapshotBG.addChild(bgBitmap);

				this.setSnapshotCharacterCostume(this.snapshotModeMovieClip.snapshotContainer1_1, cm.GamePhases.CHALLENGE_SPECIFIC_COSTUME);
				label = 'burst1';
				break;
				
			case cm.GamePhases.CHALLENGE_COLORPATTERN_COSTUME:

				bgBitmap = new cjs.Bitmap(this._getSnapshotBGImg(cm.GamePhases.CHALLENGE_COLORPATTERN_COSTUME));
				this.snapshotModeMovieClip.snapshotContainer2_2.snapshotBG.addChild(bgBitmap);

				this.setSnapshotCharacterCostume(this.snapshotModeMovieClip.snapshotContainer2_2, cm.GamePhases.CHALLENGE_COLORPATTERN_COSTUME);
				label = 'burst2';
				break;

			case cm.GamePhases.CHALLENGE_FREEPLAY:
				this.setAllSnapshotBGs();
				this.setSnapshotCharacterCostume(this.snapshotModeMovieClip.snapshotContainer3_1, cm.GamePhases.CHALLENGE_SPECIFIC_COSTUME);
				this.setSnapshotCharacterCostume(this.snapshotModeMovieClip.snapshotContainer3_2, cm.GamePhases.CHALLENGE_COLORPATTERN_COSTUME);
				this.setSnapshotCharacterCostume(this.snapshotModeMovieClip.snapshotContainer3_3, cm.GamePhases.CHALLENGE_FREEPLAY);
				label = 'burst3_complete';
				break;

			default:
				break;
		}

		var charName = cm.app.game.currentCharacterName;
		if (this.challengeSetType === 'like')
		{
			this.characterLipsyncContainer.playLipsync(
				charName + '_' + this.challengeSetType + '-' + this.challengeSetConfig.solution_name + '_complete',
				this.playCompleteResponse.bind(this)
			);
		}
		else
		{
			this.characterLipsyncContainer.playLipsync(
				charName + "_" + this.challengeSetType + "_complete",
				this.playCompleteResponse.bind(this)
			);
		}
		
	};

	p.playCompleteResponse = function() 
	{
		var alias;
		var charName = cm.app.game.currentCharacterName;

		if (this.challengeSetType === 'like')
		{
			alias = charName + '_' + this.challengeSetType + '-' + this.challengeSetConfig.solution_name + '_completeResponse';
		}
		else
		{
			alias = charName + "_" + this.challengeSetType + "_completeResponse";
		}

		var vo = cm.soundDictionary.getSoundID([
			alias, 
			charName + "_snapshot_takePicture" + [1, 2, 3].random()
		]);
		cm.app.voPlayer.play(vo, this.gotoSnapshotMode.bind(this));

	};

	p.gotoSnapshotMode = function() 
	{
		var label;
		this.addChild(this.snapshotModeMovieClip);
		this.characterMovieClip.visible = false;
		this.challengeSetItemButtons.visible = false;
		this.snapshotModeMovieClip.gotoAndStop(0);


		switch (cm.app.game.currentGamePhase) 
		{
			case cm.GamePhases.CHALLENGE_SPECIFIC_COSTUME:
				label = 'burst1';
				break;
			case cm.GamePhases.CHALLENGE_COLORPATTERN_COSTUME:
				label = 'burst2';
				break;
			case cm.GamePhases.CHALLENGE_FREEPLAY:
				label = 'burst3_complete';
				break;
			default:
				break;
		}

		this.bg.image = cm.Assets.lib.ChallengeNoLightBG;
		cm.app.sound.play('camera');
		this.snapshotModeMovieClip.onAnimationEndCallback = this.snapshotComplete.bind(this);
		this.snapshotModeMovieClip.gotoAndPlay(label);
	};


	p.setSnapshotCharacterCostume = function(snapshotContainer, gamePhase) 
	{

		var costumeName;
		var costumeLibName;
		var characterMovieClip;

		var i = 1;
		var instance;
		var name;

		snapshotContainer.gotoAndStop(0);
		snapshotContainer.button.gotoAndStop('up');
		instance = snapshotContainer.instance;


		// TODO: maybe target eye movieclips so they aren't blinking in the snapshots..
		while (instance)
		{
			if (instance.className === 'mc_paperdoll_' + cm.app.game.currentCharacterName + '_snapshotPoses') {
				characterMovieClip = instance;
			} else if (instance.className.indexOf('mc_paperdoll') === 0) {
				// Hide abby if we're dressing elmo, hide elmo if we're dressing abby.
				instance.visible = false;
			}

			instance = snapshotContainer['instance_'+i];
			i++;
		}

		// Alternate the poses..
		if (!this._snapshotPoseCount || this._snapshotPoseCount === 2)
		{
			characterMovieClip.gotoAndStop('pose_1');
			this._snapshotPoseCount = 1;
		}
		else if (this._snapshotPoseCount === 1)
		{
			characterMovieClip.gotoAndStop('pose_2');
			this._snapshotPoseCount = 2;
		}

		// Stop all that dang creepy blinking these photographs are doing.
		var charName = characterMovieClip.className.split('_')[2];
		var head = characterMovieClip.getBodypartInstances('mc_' + charName + '_container_head')[0];
		head.eyes.gotoAndStop(0);
		head.eyes.mode = 'single';

		costumeName = cm.app.game.selectedCostumes[gamePhase].top;
		costumeLibName = costumeName.replace(/Color|Pattern/g, '') + cm.app.game.costumePartsLibIDSlug;
		this.changeCostumeTop(costumeLibName, costumeName, characterMovieClip);

		costumeName = cm.app.game.selectedCostumes[gamePhase].middle;
		costumeLibName = costumeName.replace(/Color|Pattern/g, '') + cm.app.game.costumePartsLibIDSlug;
		this.changeCostumeMiddle(costumeLibName, costumeName, characterMovieClip);

		costumeName = cm.app.game.selectedCostumes[gamePhase].bottom;
		costumeLibName = costumeName.replace(/Color|Pattern/g, '') + cm.app.game.costumePartsLibIDSlug;
		this.changeCostumeBottom(costumeLibName, costumeName, characterMovieClip);

	};


	p.snapshotComplete = function() 
	{
		switch (cm.app.game.currentGamePhase) 
		{
			case cm.GamePhases.CHALLENGE_SPECIFIC_COSTUME:
			case cm.GamePhases.CHALLENGE_COLORPATTERN_COSTUME:

				cjs.Tween.get(this) 
					.wait(1000)
					.call(cm.app.game.gotoChallenge, [cm.app.game.currentCharacterName], cm.app.game);
				break;

			case cm.GamePhases.CHALLENGE_FREEPLAY:

				this.snapshotModeMovieClip.snapshotContainer3_1.gamePhase = cm.GamePhases.CHALLENGE_SPECIFIC_COSTUME;
				this.snapshotModeMovieClip.snapshotContainer3_2.gamePhase = cm.GamePhases.CHALLENGE_COLORPATTERN_COSTUME;
				this.snapshotModeMovieClip.snapshotContainer3_3.gamePhase = cm.GamePhases.CHALLENGE_FREEPLAY;

				this.snapshotModeMovieClip.snapshotContainer3_1.mouseChildren = false;
				this.snapshotModeMovieClip.snapshotContainer3_2.mouseChildren = false;
				this.snapshotModeMovieClip.snapshotContainer3_3.mouseChildren = false;

				cm.app.voPlayer.play(cm.soundDictionary.getSoundID(cm.app.game.currentCharacterName + '_snapshot_choosePictureIntro'));

				this.isInSnapshotMode = true;

				this.snapshotModeMovieClip.on('click', this.snapshotsInteractionHandler, this);

				if (!cm.Device.mobile) {
					this.snapshotModeMovieClip.on('mouseover', this.snapshotsInteractionHandler, this);
					this.snapshotModeMovieClip.on('mouseout', this.snapshotsInteractionHandler, this);
				}
				break;

			default:
				break;
		}
	};


	p.snapshotsInteractionHandler = function(e) 
	{
		switch (e.type) 
		{
			case 'click':
				cm.app.sound.play('click3');
				cm.app.voPlayer.stop();
				this.snapshotModeMovieClip.mouseEnabled = false;
				cm.analytics.event('ButtonSelectionDanceSlot', 'Picture_Round ' + e.target.gamePhase + ' Picture', null);
				cm.app.game.gotoDanceoff(e.target.gamePhase);
				break;
			case 'mouseover':
				cm.app.game.hoverCursor();
				cm.app.sound.play('ro4', {volume: 0.5});
				e.target.button.gotoAndStop('over');
				break;
			case 'mouseout': 
				cm.app.game.unhoverCursor();
				e.target.button.gotoAndStop('up');
				break;
			default:
				break;
		}

	};


	p.changeCostumeTop = function(costumeLibName, costumeName, characterMovieClip) 
	{	
		var charName = cm.app.game.currentCharacterName;
		var part;
		var partClass;

		cm.app.game.addCostumeParts({
			costumeLib: cm.Assets.lib[costumeLibName],
			characterMovieClip: characterMovieClip,
			charName: charName,
			partName: 'head',
			costumeName: costumeName
		});

	};

	p.changeCostumeMiddle = function(costumeLibName, costumeName, characterMovieClip) 
	{	


		var charName = cm.app.game.currentCharacterName;
		var part;
		var partClass;

		var partNames = [
			'torso',
			'cape',
			'upperarm',
			'lowerarm',
			'hand',
			'upperleg'
		];

		for (var i = 0, l = partNames.length; i < l; i++) 
		{
			cm.app.game.addCostumeParts({
				costumeLib: cm.Assets.lib[costumeLibName],
				characterMovieClip: characterMovieClip,
				charName: charName,
				partName: partNames[i],
				costumeName: costumeName
			});
		}


		cm.app.game.addCostumeParts({
			costumeLib: cm.Assets.lib[costumeLibName],
			characterMovieClip: characterMovieClip,
			charName: charName,
			partName: 'lowerleg',
			lowerLegSegment: 'M',
			costumeName: costumeName
		});
	};

	p.changeCostumeBottom = function(costumeLibName, costumeName, characterMovieClip) 
	{
		var charName = cm.app.game.currentCharacterName;
		var part;
		var partClass;

		// Feet
		cm.app.game.addCostumeParts({
			costumeLib: cm.Assets.lib[costumeLibName],
			characterMovieClip: characterMovieClip,
			charName: charName,
			partName: 'foot',
			costumeName: costumeName
		});

		// lower legs (ugh... handling an exceptional case for the pirate boots >:| )
		cm.app.game.addCostumeParts({
			costumeLib: cm.Assets.lib[costumeLibName],
			characterMovieClip: characterMovieClip,
			charName: charName,
			partName: 'lowerleg',
			lowerLegSegment: 'B',
			costumeName: costumeName
		});

	};

	p._getSnapshotBGImg = function(gamePhase)
	{
		var img;
		var costumeID;

		console.log(cm.app.game.howManySameOutfitParts(gamePhase));

		if (cm.app.game.howManySameOutfitParts(gamePhase) === cm.app.config.main_config.matchOutfitToBackgroundRequirement)
		{
			costumeID = cm.app.game.getBGNameForCostume(cm.app.game.getMajorityCostumeType(gamePhase));
			img = cm.Assets.lib[costumeID + 'SnapshotBG'];
		}
		else 
		{
			img = cm.Assets.lib.freeplaySnapshotBG;
		}

		return img;
	};


	p.setAllSnapshotBGs = function() 
	{
		var img;

		img = this._getSnapshotBGImg(cm.GamePhases.CHALLENGE_SPECIFIC_COSTUME);
		bgBitmap = new cjs.Bitmap(img);
		this.snapshotModeMovieClip.snapshotContainer3_1.snapshotBG.addChild(bgBitmap);

		img = this._getSnapshotBGImg(cm.GamePhases.CHALLENGE_COLORPATTERN_COSTUME);
		bgBitmap = new cjs.Bitmap(img);
		this.snapshotModeMovieClip.snapshotContainer3_2.snapshotBG.addChild(bgBitmap);

		img = this._getSnapshotBGImg(cm.GamePhases.CHALLENGE_FREEPLAY);
		bgBitmap = new cjs.Bitmap(img);
		this.snapshotModeMovieClip.snapshotContainer3_3.snapshotBG.addChild(bgBitmap);
	};


	p.startInSnapshotMode = function() 
	{

		this.isInSnapshotMode = true;

		this.bg.image = cm.Assets.lib.ChallengeNoLightBG;

		cm.app.voPlayer.play(cm.soundDictionary.getSoundID(cm.app.game.currentCharacterName + '_snapshot_choosePictureIntro'));

		this.setAllSnapshotBGs();

		this.addChild(this.snapshotModeMovieClip);
		
		this.setSnapshotCharacterCostume(this.snapshotModeMovieClip.snapshotContainer3_1, cm.GamePhases.CHALLENGE_SPECIFIC_COSTUME);
		this.setSnapshotCharacterCostume(this.snapshotModeMovieClip.snapshotContainer3_2, cm.GamePhases.CHALLENGE_COLORPATTERN_COSTUME);
		this.setSnapshotCharacterCostume(this.snapshotModeMovieClip.snapshotContainer3_3, cm.GamePhases.CHALLENGE_FREEPLAY);
		label = 'burst3_complete';

		this.snapshotModeMovieClip.onAnimationEndCallback = this._startInSnapshotMode.bind(this);
		this.snapshotModeMovieClip.gotoAndPlay(label);
	};

	p._startInSnapshotMode = function() 
	{
		this.snapshotModeMovieClip.snapshotContainer3_1.gamePhase = cm.GamePhases.CHALLENGE_SPECIFIC_COSTUME;
		this.snapshotModeMovieClip.snapshotContainer3_2.gamePhase = cm.GamePhases.CHALLENGE_COLORPATTERN_COSTUME;
		this.snapshotModeMovieClip.snapshotContainer3_3.gamePhase = cm.GamePhases.CHALLENGE_FREEPLAY;

		this.snapshotModeMovieClip.snapshotContainer3_1.mouseChildren = false;
		this.snapshotModeMovieClip.snapshotContainer3_2.mouseChildren = false;
		this.snapshotModeMovieClip.snapshotContainer3_3.mouseChildren = false;

		this.snapshotModeMovieClip.on('click', this.snapshotsInteractionHandler, this);

		if (!cm.Device.mobile) 
		{
			this.snapshotModeMovieClip.on('mouseover', this.snapshotsInteractionHandler, this);
			this.snapshotModeMovieClip.on('mouseout', this.snapshotsInteractionHandler, this);
		}
	};


	p.sendAnalyticsTimeout = function() 
	{
		if (this.isInSnapshotMode)
		{
			cm.analytics.timeoutFired('Snapshot Round ' + cm.app.game.currentGamePhase, this.challengeSetConfig.analytics_name);			
		} 
		else 
		{
			cm.analytics.timeoutFired('Dressup Round ' + cm.app.game.currentGamePhase, this.challengeSetConfig.analytics_name);
		}

	};	

	p.onUserReEngage = function() 
	{
		if (this.isInSnapshotMode)
		{
			cm.analytics.userReengage('Snapshot Round ' + cm.app.game.currentGamePhase, this.challengeSetConfig.analytics_name);			
		} 
		else 
		{
			cm.analytics.userReengage('Dressup Round ' + cm.app.game.currentGamePhase, this.challengeSetConfig.analytics_name);
		}
	};


	p.update = function(deltaT)
	{

		this.menuBtn.set({x: -cm.app.display.width/2, y: -cm.app.display.height/2});

		if (this.idleAllowed)
		{			

			this.idleTimer += deltaT;

			if (cm.app.voPlayer.playing)
			{
				// keep idles from interfering with lines resulting from user interaction.
				this.idleTimer = 0;
			}

			if (this.idleTimer > 15000) 
			{
				this.idleTimer = 0;

				this.sendAnalyticsTimeout();

				var charName = cm.app.game.currentCharacterName;

				if (this.isInSnapshotMode)				
				{
					cm.app.voPlayer.play(cm.soundDictionary.getSoundID(charName + '_snapshot_choosePictureIdle' + Math.range(1, 3)));
				
					var btns = [
						this.snapshotModeMovieClip.snapshotContainer3_1.button,
						this.snapshotModeMovieClip.snapshotContainer3_2.button,
						this.snapshotModeMovieClip.snapshotContainer3_3.button
					];

					for (var i = 0, l = btns.length; i < l; i++)
					{
						cjs.Tween.get(btns[i])
							.call(btns[i].gotoAndStop, ['over'], btns[i])
							.wait(500)
							.call(btns[i].gotoAndStop, ['up'], btns[i])
							.wait(500)
							.call(btns[i].gotoAndStop, ['over'], btns[i])
							.wait(500)
							.call(btns[i].gotoAndStop, ['up'], btns[i]);
					}

				}
				else 
				{

					// Idle hints
					this.hintTotal++;

					if (this.idleType === 1)
					{
						// Just says: "put something on {charName}"
						cm.app.voPlayer.play(cm.soundDictionary.getSoundID(charName + '_challengeIdle1'));
						this.idleType = 2;
					}
					else if (this.idleType === 2)
					{
					
						if (this.challengeSetType === 'free')
						{
							// "Dress up {charName} in anything you want"
							cm.app.voPlayer.play(cm.soundDictionary.getSoundID(charName + '_challengeIdle2_free'));
						}
						else 
						{
							// Prompts user to dress character specifically to the challenge set
							// eg: dress elmo in the color orange
							cm.app.voPlayer.play(cm.soundDictionary.getSoundID([
								// eg: "elmo_challengeIdle2_like"
								charName + '_challengeIdle2_' + this.challengeSetType, 
								// eg: "elmo_like-bear_roundIntro"
								charName + '_' + this.challengeSetType + '-' + this.challengeSetConfig.solution_name + '_roundIntro'
							]));
						}

						this.idleType = 3;
					
					}
					else if (this.idleType === 3)
					{

						// For costume part specific idle hints
						// If top, middle, or bottom are missing.

						var idleLines = [];
						var selectedCostumes = cm.app.game.selectedCostumes[cm.app.game.currentGamePhase];
						var charName = cm.app.game.currentCharacterName;

						if (selectedCostumes.top === undefined)
						{
							// eg: elmo_challengeIdle3_topMissing
							idleLines.push(charName + '_challengeIdle3_topMissing');
						}
						else if (selectedCostumes.middle === undefined)
						{
							idleLines.push(charName + '_challengeIdle3_middleMissing');
						}
						else if (selectedCostumes.bottom === undefined)
						{
							idleLines.push(charName + '_challengeIdle3_bottomMissing');
						}

						if (idleLines.length > 0)
						{
							cm.app.voPlayer.play(cm.soundDictionary.getSoundID(
								idleLines.random()
							));
						}

						this.idleType = 1;

					}
				}
			}
		}

		if (this.interactionTarget !== null && this.itemFollowingCursor)
		{
			var s = cm.app.display.stage;
			this.interactionTarget.parent.globalToLocal(s.mouseX, s.mouseY, this.interactionTarget);
		}

		// make the costume pieces "float"  in the air
		for (var i = 0, l = this.activeGarmentButtons.length; i < l; i++)
		{
			var gb = this.activeGarmentButtons[i];
			if (gb._isInteracting)
			{
				continue;
			}

			
			gb._floatingTime += deltaT;

			gb.regX = gb._defaultRegX + 5 * Math.cos(0.0007 * gb._floatingTime + gb.floatPhaseOffset);
			gb.regY = gb._defaultRegY + 5 * Math.sin(0.0007 * gb._floatingTime + gb.floatPhaseOffset);
		}

	};


	cm.View.Challenge = cjs.promote(Challenge, "View");

})();

/*jshint ignore:end*/